<template>
    <b-modal id="order-template-modal" @ok="handleOk" header-class="p-0"
        footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
        <template #modal-title>
            <div class="title-block text-center p-2">{{ $translate('create_template') }}</div>
            <div class="close-btn" @click="cancel()">x</div>
        </template>
        <form class="my-3 py-3" @submit.stop.prevent="createTemplate">

            <b-col cols="12">
                <label class="mb-3"><strong>{{ $translate('name') }}</strong></label>
                <b-form-input id="order-template-name" placeholder="Enter the name of the activity template"
                    v-model="model.order_template_name" required>
                </b-form-input>
            </b-col>
            <b-col cols="12" class="mt-4 dd">
                <label class="mb-3"><strong>{{ $translate('category') }}</strong></label>
                <b-form-select class="form-control" id="order_category_id" v-model="model.order_category_id" required
                    :options="categories.map(x => ({
                        value: x.id,
                        text: x.name,
                    }))
                        ">
                    <template #first>
                        <b-form-select-option :value="null"
                            disabled>{{ $translate('select_template_category') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
        </form>
        <template #modal-footer="{ ok, cancel }">
            <b-button id="create-template-btn" class="test-create-template-btn" size="sm" variant="info" @click="ok()">{{ $translate('create_template') }}</b-button>
            <b-button id="cancel-btn" class="test-cancel-btn" size="sm" variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>

        </template>
    </b-modal>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    mixins: [popupMixins],
    data() {
        return {
            model: {
                order_category_id: null,
                order_template_name: null,
            },
        }
    },

    filters: {},
    created() {
        this.$store.dispatch('orderCategory/fetchAll')
    },
    mounted() { },
    watch: {
        order_template_id: function (val) {
            this.$emit('input', val)
        },
        'model.order_template_name': function (name) {
            this.model.order_template_name = name
            this.$emit('input', this.model)
        },
        'model.order_category_id': function (id) {
            this.model.order_category_id = id
            this.$emit('input', this.model)
        },
    },
    computed: {
        categories() {
            return this.$store.state.orderCategory.categories
        },
        order() {
            const item = this.$store.state.orders.item
            return item || {}
        },
    },

    methods: {
        showModal() {
            this.$bvModal.show('order-template-modal')
        },

        async createNewTemplate() {
            await this.$store.dispatch('orderTemplate/create', this.model)
        },

        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            // Trigger submit handler
            this.createTemplate()
        },

        async createTemplate() {
            try {
                const template = {
                    order_category_id: this.model.order_category_id,
                    name: this.model.order_template_name,
                    description: this.order.description,
                }
                const { id } = this.order
                const data = await this.$store.dispatch(
                    'orders/createTemplate',
                    {
                        id,
                        template,
                    }
                )
                this.$bvModal.hide('order-template-modal')
                this.doToast(
                    this.$translate('success'),
                    `${this.$translate('activity_template')} ${this.$translate('create_alert')}`,
                    'success'
                )
                console.log(data)
            } catch (err) {
                const responseMessage = err.response.data.error.message
                let errorMessage = this.$translate('unable_activity_template')
                console.log(err.response.data.error)

                // Check if the fields have not been set
                if (responseMessage.includes('cannot be null')) {
                    errorMessage +=
                        this.$translate('activity_template_null')

                    // Checks if the order template already exists
                } else if (responseMessage.includes('Duplicate entry')) {
                    errorMessage +=
                    this.$translate('activity_template_duplicate')
                } else {
                    errorMessage += responseMessage
                }

                this.doToast(this.$translate('error'), errorMessage, 'danger')
            }
        },
    },
}
</script>
